import { Stack, styled, Typography } from '@mui/material';

export const IdentifyCustomerContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(1),
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    maxWidth: 360,
  },
}));

export const IdentifyCustomerTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  ...theme.typography.h3,
  [theme.breakpoints.up('lg')]: {
    ...theme.typography.h2,
    textAlign: 'left',
  },
}));

export const IdentifyCustomerTitleHighlight = styled(Typography)(
  ({ theme }) => ({
    ...theme.typography.h3,
    textAlign: 'center',
    color: theme.palette.primaries[400],
    [theme.breakpoints.up('lg')]: {
      ...theme.typography.h2,
      textAlign: 'left',
    },
  }),
);

export const IdentifyCustomerDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.neutral[800],
  marginBottom: theme.spacing(1),
  [theme.breakpoints.up('lg')]: {
    ...theme.typography.body1,
    textAlign: 'left',
    marginBottom: theme.spacing(2),
  },
}));
